module.exports = __webpack_public_path__ + "res/img/avatatr_no_g.6744685c.png";